const productTypeFlags = Object.freeze({
	groupedProduct: 10,
	simpleProduct: 5,
})

const productTypes = Object.freeze({
	Simple: 'SimpleProduct',
	Grouped: 'GroupedProduct',
})

export { productTypeFlags, productTypes }
